var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGraphs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.75 59V9.5H38.75V59H29.75V27.5H11.75V59H5V0.5H0.5V59C0.5 60.2 0.98 61.34 1.82 62.18C2.66 63.02 3.8 63.5 5 63.5H63.5V59H56.75ZM25.25 59H16.25V32H25.25V59ZM52.25 59H43.25V14H52.25V59Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGraphs);
export default __webpack_public_path__ + "static/media/ic-graphs.b58d130e617e6dcf455204eafe30bf50.svg";
export { ForwardRef as ReactComponent };